import { isApiMethodItems } from '../../../../utils/isApiMethodItems';
import { MAX_SELECTED_LABELS_FOR_MULTISELECT } from '../../../../constants';
import { ControlItems } from '../../../../types/types';

// Returns true when a popover control must fetch options on render instead of lazily.
// Needed when a stored value requires label lookup: apiMethod items, value present,
// labelItem differs from valueItem.
// For multiCheckbox: only when selected count < MAX_SELECTED_LABELS_FOR_MULTISELECT.
export const shouldFetchEagerly = (
  isPopoverControl: boolean,
  controlItems: ControlItems | undefined,
  value: unknown,
  controlType: string | undefined
): boolean => {
  if (!isPopoverControl || !controlItems || !isApiMethodItems(controlItems))
    return false;
  const valueArray = value ? value.toString().split(',') : [];
  const hasValue = value
    ? valueArray.length > 0
    : value != null && value !== '';
  if (!hasValue) return false;

  const { labelItem, valueItem } = controlItems;
  if (!labelItem || labelItem === valueItem) return false;
  if (controlType === 'multiCheckbox') {
    return valueArray.length <= MAX_SELECTED_LABELS_FOR_MULTISELECT;
  }
  return true; // combobox: all conditions met
};
